import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { aboutData } from '@/mocks/about';

export default function AboutPage() {
  return (
    <>
      <Navbar />
      <main className="pt-16">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: '首页', path: '/' },
              { label: '关于我们' },
            ]}
          />
        </div>

        <section className="py-14 md:py-20 bg-background-50">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="text-center mb-14">
              <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
                关于{aboutData.brand.name}
              </h1>
              <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto">
                成立于{aboutData.brand.established} · 总部位于{aboutData.brand.headquarters}
              </p>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-16">
              {aboutData.stats.map((stat) => (
                <div key={stat.label} className="text-center p-6 rounded-2xl bg-background-100 border border-background-200/70">
                  <div className="font-heading text-3xl md:text-4xl font-bold text-primary-500 mb-2">
                    {stat.value}
                  </div>
                  <div className="text-sm text-foreground-500">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="max-w-4xl mx-auto mb-16">
              <h2 className="font-heading text-2xl font-bold text-foreground-900 mb-6 text-center">品牌故事</h2>
              <div className="space-y-4">
                {aboutData.brand.description.map((p, i) => (
                  <p key={i} className="text-foreground-600 leading-relaxed text-sm md:text-base">
                    {p}
                  </p>
                ))}
              </div>
            </div>

            <div className="mb-16">
              <h2 className="font-heading text-2xl font-bold text-foreground-900 mb-8 text-center">核心价值观</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
                {aboutData.values.map((value) => (
                  <div
                    key={value.title}
                    className="p-6 rounded-2xl bg-background-100 border border-background-200/70 text-center hover:border-primary-200 transition-all duration-300"
                  >
                    <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-primary-50 text-primary-500 mx-auto mb-4">
                      <i className={`${value.icon} text-2xl`}></i>
                    </div>
                    <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">{value.title}</h3>
                    <p className="text-sm text-foreground-500">{value.description}</p>
                  </div>
                ))}
              </div>
            </div>

            <div className="mb-16">
              <h2 className="font-heading text-2xl font-bold text-foreground-900 mb-8 text-center">核心团队</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
                {aboutData.teamMembers.map((member) => (
                  <div
                    key={member.name}
                    className="p-6 rounded-2xl bg-background-100 border border-background-200/70 text-center"
                  >
                    <div className="w-16 h-16 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 font-heading text-xl font-bold mx-auto mb-4">
                      {member.name.slice(-2)}
                    </div>
                    <h3 className="font-heading text-base font-semibold text-foreground-900 mb-1">{member.name}</h3>
                    <p className="text-xs text-primary-500 font-medium mb-3">{member.role}</p>
                    <p className="text-xs text-foreground-500 leading-relaxed">{member.description}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-100">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <h2 className="font-heading text-2xl font-bold text-foreground-900 mb-8 text-center">用户口碑</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {aboutData.testimonials.map((testimonial) => (
                <div
                  key={testimonial.name}
                  className="p-6 rounded-2xl bg-background-50 border border-background-200/70"
                >
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 font-heading text-sm font-bold">
                      {testimonial.avatar}
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-900">{testimonial.name}</p>
                      <p className="text-xs text-foreground-400">{testimonial.role}</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-0.5 mb-3">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i
                        key={i}
                        className={`text-xs ${i < testimonial.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-200'}`}
                      ></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">{testimonial.content}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-50">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <h2 className="font-heading text-2xl font-bold text-foreground-900 mb-8 text-center">联系我们</h2>
            <div className="max-w-2xl mx-auto">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                <div className="p-5 rounded-xl bg-background-100 border border-background-200/70">
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-50 text-primary-500 mb-3">
                    <i className="ri-mail-line text-lg"></i>
                  </div>
                  <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-1">电子邮箱</h3>
                  <p className="text-sm text-foreground-500">{aboutData.contact.email}</p>
                </div>
                <div className="p-5 rounded-xl bg-background-100 border border-background-200/70">
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-accent-50 text-accent-500 mb-3">
                    <i className="ri-wechat-line text-lg"></i>
                  </div>
                  <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-1">微信公众号</h3>
                  <p className="text-sm text-foreground-500">{aboutData.contact.wechat}</p>
                </div>
                <div className="p-5 rounded-xl bg-background-100 border border-background-200/70">
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-secondary-50 text-secondary-500 mb-3">
                    <i className="ri-weibo-line text-lg"></i>
                  </div>
                  <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-1">官方微博</h3>
                  <p className="text-sm text-foreground-500">{aboutData.contact.weibo}</p>
                </div>
                <div className="p-5 rounded-xl bg-background-100 border border-background-200/70">
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-50 text-primary-500 mb-3">
                    <i className="ri-phone-line text-lg"></i>
                  </div>
                  <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-1">客服电话</h3>
                  <p className="text-sm text-foreground-500">{aboutData.contact.phone}</p>
                </div>
              </div>
              <div className="mt-5 p-5 rounded-xl bg-background-100 border border-background-200/70">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-accent-50 text-accent-500 mb-3">
                  <i className="ri-map-pin-line text-lg"></i>
                </div>
                <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-1">公司地址</h3>
                <p className="text-sm text-foreground-500">{aboutData.contact.address}</p>
                <p className="text-xs text-foreground-400 mt-2">工作时间：{aboutData.contact.workHours}</p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}